<template>
  <div class="config-options">
    <!-- <h1>loop</h1> -->
    <swatch-list :options="options.Options" option="Loop"></swatch-list>
  </div>
</template>

<script>
import store from "../../store";
import SwatchList from "./SwatchList.vue";

export default {
  name: "loop",
  computed: {
    options() {
      return store.state.productOptions.Loop;
    }
  },
  components: { SwatchList }
};
</script>
<style lang="scss" scoped>
</style>